import { render, staticRenderFns } from "./Expert2RejectComment.vue?vue&type=template&id=19887f86&"
import script from "./Expert2RejectComment.vue?vue&type=script&lang=js&"
export * from "./Expert2RejectComment.vue?vue&type=script&lang=js&"
import style0 from "./Expert2RejectComment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports